import { useMutation, useQueryClient } from '@tanstack/react-query';

import { roleApi } from '../api/role.adapter';
import type {
  CreateRoleInput,
  DeleteRoleResult,
  Role,
  UpdateRoleInput,
} from '../types/role.types';
import { roleQueryKeys } from './use-roles';

export function useUpdateRole() {
  const qc = useQueryClient();
  return useMutation<Role, Error, { id: number; input: UpdateRoleInput }>({
    mutationFn: ({ id, input }) => roleApi.updateRole(id, input),
    onSuccess: (updated) => {
      qc.invalidateQueries({ queryKey: roleQueryKeys.list() });
      qc.setQueryData(roleQueryKeys.detail(updated.id), updated);
    },
  });
}

export function useCreateRole() {
  const qc = useQueryClient();
  return useMutation<Role, Error, CreateRoleInput>({
    mutationFn: (input) => roleApi.createRole(input),
    onSuccess: (created) => {
      qc.invalidateQueries({ queryKey: roleQueryKeys.list() });
      qc.setQueryData(roleQueryKeys.detail(created.id), created);
    },
  });
}

export function useDeleteRole() {
  const qc = useQueryClient();
  return useMutation<DeleteRoleResult, Error, number>({
    mutationFn: (id) => roleApi.deleteRole(id),
    onSuccess: (_result, id) => {
      qc.invalidateQueries({ queryKey: roleQueryKeys.list() });
      qc.removeQueries({ queryKey: roleQueryKeys.detail(id) });
    },
  });
}
